/* Un personaje (fantasma) cruza la pantalla de lado a lado mientras se hace scroll por el Texto SEO.
   Va detrás del texto, tenue, y solo existe dentro de la sección. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SPEED = { lento: 2.7, normal: 1.8, rapido: 1.15 };

  function ease(x) { return 0.5 - 0.5 * Math.cos(Math.PI * x); }

  function setup(layer) {
    if (reduce || layer.getAttribute('data-ready')) return;
    layer.setAttribute('data-ready', '1');
    var section = layer.closest('[data-kb-pseo]');
    var imgs = Array.prototype.slice.call(layer.querySelectorAll('img'));
    if (!section || !imgs.length) return;
    var per = SPEED[layer.getAttribute('data-speed')] || SPEED.normal;
    var base = parseFloat(layer.getAttribute('data-opacity')) || 0.4;
    var lw = 0, lh = 0, gw = 0, active = false, queued = false;

    function measure() {
      lw = layer.clientWidth; lh = layer.clientHeight;
      gw = imgs[0].getBoundingClientRect().width || imgs[0].offsetWidth || 200;
    }
    function frame() {
      queued = false;
      if (!active) return;
      var r = section.getBoundingClientRect();
      var vh = window.innerHeight || 800;
      var scrolled = vh - r.top;
      var total = r.height + vh;
      var t0 = scrolled / (Math.max(vh, 600) * per);
      var edge = Math.max(0, Math.min(1, scrolled / (vh * 0.35), (total - scrolled) / (vh * 0.35)));
      for (var i = 0; i < imgs.length; i++) {
        var t = t0 - i * 0.05;
        var u = ((t % 2) + 2) % 2;
        var going = u < 1;
        var x = -gw + ease(going ? u : 2 - u) * (lw + gw);
        var y = lh * 0.5 - gw * 0.5 + Math.sin(t * Math.PI * 2.3 + i * 0.35) * lh * 0.16;
        var rot = Math.sin(t * Math.PI * 2.3 + 1) * 7;
        var fade = i === 0 ? 1 : (i === 1 ? 0.42 : 0.2);
        var o = base * fade * edge * (0.9 + 0.1 * Math.sin(t * 9));
        imgs[i].style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0) rotate(' + rot.toFixed(1) + 'deg) scaleX(' + (going ? -1 : 1) + ')';
        imgs[i].style.opacity = o.toFixed(3);
      }
    }
    function queue() { if (!queued) { queued = true; requestAnimationFrame(frame); } }

    measure();
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', function () { measure(); queue(); });
    imgs[0].addEventListener('load', function () { measure(); queue(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { active = es[0].isIntersecting; if (active) { measure(); queue(); } }, { rootMargin: '10% 0px' }).observe(section);
    } else { active = true; queue(); }
  }

  function init() { Array.prototype.forEach.call(document.querySelectorAll('[data-kb-ghost]'), setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
